
import { createApp } from "vue";
import VisitorModal from "~/components/StaticPages/Samples/VisitorModal";
import SampleContentModal from "~/components/StaticPages/Samples/SampleContentModal";

$(function () {
  var clickFlg_list = true;
  var clickid_list = "";
  $(".sample_tr").css(
    "margin-top",
    $(".sample_list_index_box").height() / 2 - 70
  );

  function mouseover() {
    if (clickid_list != $(this).attr("id")) {
      clickFlg_list = true;
      $(this).addClass("select_list");
    }
  }

  function mouseout() {
    if (clickFlg_list && clickid_list != $(this).attr("id")) {
      $(this).removeClass("select_list");
    }
  }

  function click() {
    var elementid = $(this).attr("id");
    $(".select_list").removeClass("select_list");
    $(this).addClass("select_list");
    $(".sample_list_hide .detail_show").hide();
    $(".sample_list_hide .detail_show").removeClass("detail_show");
    $(".sample_list_hide #" + elementid).show("drop", "", 300);
    $(".sample_list_hide #" + elementid).addClass("detail_show");
    if (
      $(".sample_list_index_box").height() / 2 -
        $(".detail_show").height() / 2 >
      0
    )
      $(".detail_show").css(
        "margin-top",
        $(".sample_list_index_box").height() / 2 -
          $(".detail_show").height() / 2
      );
    clickFlg_list = false;
    clickid_list = elementid;
  }

  const lists = document.querySelectorAll(".samples_list");
  lists.forEach(list => {
    list.addEventListener("mouseover", mouseover);
    list.addEventListener("mouseout", mouseout);
    list.addEventListener("click", click);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const app = createApp({
    components: {
      VisitorModal,
      SampleContentModal
    }
  });
  app.mount("#contents");
});
